"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visibleIntakeQuestions = exports.intakeConditionsMatch = exports.DEFAULT_STORE_ENTRY = void 0;
exports.DEFAULT_STORE_ENTRY = {
    mode: "direct",
    programIds: [],
    directLabel: "Choose my treatment",
    guidedLabel: "Help me choose",
    introduction: "",
};
function intakeConditionsMatch(conditions, answers) {
    return conditions.every((c) => {
        const value = answers[c.questionId];
        if (value === undefined)
            return false;
        return c.operator === "eq"
            ? value === c.value
            : typeof value === "number" &&
                typeof c.value === "number" &&
                (c.operator === "gte" ? value >= c.value : value <= c.value);
    });
}
exports.intakeConditionsMatch = intakeConditionsMatch;
function visibleIntakeQuestions(program, answers, context = {}) {
    const visible = [];
    const scoped = {};
    for (const q of program.questions) {
        if (q.paths?.length && (!context.path || !q.paths.includes(context.path)))
            continue;
        if (q.planIds?.length &&
            (!context.planId || !q.planIds.includes(context.planId)))
            continue;
        if (!intakeConditionsMatch(q.when || [], scoped))
            continue;
        visible.push(q);
        if (Object.prototype.hasOwnProperty.call(answers, q.id))
            scoped[q.id] = answers[q.id];
    }
    return visible;
}
exports.visibleIntakeQuestions = visibleIntakeQuestions;
//# sourceMappingURL=intakeProgram.js.map